import { onlyUnique } from '~/lib/utils/array';
import { SearchObject } from './Models';
import { ExtendedOrderCache } from '~/apps/smartsend/lib/cache/ExtendedOrderCache';

const trackingNumbers = (courierId: string, tracking: string[]): string | null => {
  if (!tracking || tracking.length === 0) {
    return null;
  }

  switch (courierId) {
    case 'royal-mail':
      return tracking.filter((x) => !x.startsWith('http')).sort((a, b) => a.length - b.length)[0];
    default:
      return tracking[0];
  }
};

const additionalTags = (id: SearchObject) => {
  if (ExtendedOrderCache.refundOrderLineIds.find((x) => x.orderlineId.toString() === id.orderLineId.toString())) {
    return ['REFUND'];
  }
  return [trackingNumbers(id.service.courierSlug, id.parcelNumbers)];
};

export const GetDefaultSearchHitTags = (hit: SearchObject) => {
  let output: string[] = [];

  if (additionalTags) {
    output = output.concat(additionalTags(hit));
  }

  hit.smartSend.items.forEach((t) => {
    output.push(t.source);
    output.push(t.buyerId);
  });

  if (hit.hasClaim) {
    output.push(`CLAIM`);
  }

  return output.filter((x) => !!x).filter(onlyUnique);
};
